import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * A list element, used to wrap listitem elements
 *
 * @prop {Boolean} separator - optional, used to display separator (thin lines) between listitem elements
 * @prop {Boolean} status - optional, used to correctly display listitems with a statusbar
 * @prop {String} noPrimaryAction - optional, used to disable all pointer events on the wrapped listitem elments (used for static lists)
 * @prop {String} centerIcons - optional, used to center icons if displayed in the listitem
 * @prop {String} contentTop - optional, used to display all text content in top of listitem (instead of centering it)
 *
 * @slot - This is an unnamed slot (default slot)
 */
let SDBContentList = class SDBContentList extends LitElement {
    constructor() {
        super(...arguments);
        this.separator = false;
        this.noPrimaryAction = false;
        this.centerIcons = false;
        this.contentTop = false;
    }
    render() {
        return html ` <slot></slot> `;
    }
};
SDBContentList.styles = [
    elements,
    css `
            :host {
                position: relative;
                background: var(--sdb-content-list-background, white);
                padding: 15px 20px 40px 20px;
                display: block;
                --sdb-listitem-main-justify: center;
                --sdb-listitem-icon-padding-left: 10px;
                --sdb-listitem-icon-justify: center;
                --sdb-listitem-icon-align: start;
            }

            :host([centerIcons]) {
                --sdb-listitem-icon-justify: center;
                --sdb-listitem-icon-align: center;
                --sdb-listitem-icon-padding-left: 0;
            }

            :host([contentTop]) {
                --sdb-listitem-main-justify: start;
                --sdb-listitem-content-align: start;
            }

            :host([separator]) {
                --sdb-list-separator: var(--separator-color);
            }

            :host([status]) {
                --sdb-list-status: 2px;
            }

            :host([noPrimaryAction]) > ::slotted(sdb-content-listitem) {
                pointer-events: none;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */

                :host {
                    padding: 10px 10px 30px;
                }
            }
        `,
];
__decorate([
    property({ type: Boolean })
], SDBContentList.prototype, "separator", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentList.prototype, "noPrimaryAction", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentList.prototype, "centerIcons", void 0);
__decorate([
    property({ type: Boolean })
], SDBContentList.prototype, "contentTop", void 0);
SDBContentList = __decorate([
    customElement('sdb-content-list')
], SDBContentList);
export { SDBContentList };
//# sourceMappingURL=sdb-content-list.js.map